"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var uuid_1 = require("uuid");
var sok_types_1 = require("@caddigital/sok-types");
var MetadataEditorView_1 = require("../../MetadataEditorView");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('uuid', 'setUuid', ''), (0, recompose_1.lifecycle)({
    componentWillUnmount: function () {
        this.props.setProcessed([]), this.props.setMetas([]);
    },
    componentDidMount: function () {
        this.props.setUuid((0, uuid_1.v4)());
        // Create Custom metas
        var metas = this.props.metaDataColumns.reduce(function (acc, x) {
            if (x.identifier === 'name-meta' ||
                x.identifier === 'description-meta') {
                acc.push(__assign(__assign({}, x), { editable: false }));
            }
            return acc;
        }, []);
        metas.push({
            editable: true,
            hideOnFileList: false,
            identifier: 'congrid-meta',
            mandatory: false,
            name: this.props.getLocalization('congrid/link/meta'),
            order: metas.reduce(function (next, x) { return Math.max(next, x.order + 1); }, 1),
            required: true,
            bitField: sok_types_1.CustomMeta.FILES_LIST | sok_types_1.CustomMeta.REQUIRED | sok_types_1.CustomMeta.EDITABLE,
            type: 'select',
            options: this.props.congridMetas.map(function (x, i) { return ({
                name: x.name,
                order: i,
                value: x.id
            }); })
        });
        this.props.setMetas(metas);
        // Fix revision custom metas
        var files = this.props.items.map(function (x) {
            var revisionMetas = metas.map(function (z) {
                var cur = (x.customMeta || []).find(function (x) {
                    return x.uuid === z.identifier;
                });
                return __assign(__assign({}, z), { value: cur ? cur.value : '', formattedValue: cur ? cur.value : '' });
            });
            x.customMeta = revisionMetas;
            return x;
        });
        this.props.setProcessed(files);
    }
}), recompose_1.pure);
exports.default = enhance(function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("div", { key: 'disclaimer', className: 'disclaimer' },
        React.createElement("div", null, props.getLocalization('congrid/link/wizard/step2/disclaimer'))),
    React.createElement(MetadataEditorView_1.FileList, { key: 'list', onOverrideColumn: function (x) {
            var updated = props.processed.map(function (rev) {
                ;
                rev.customMeta = (rev.customMeta || []).map(function (cm) {
                    if (cm.identifier === x.key) {
                        return __assign(__assign({}, cm), { value: x.value, formattedValue: x.value });
                    }
                    return cm;
                });
                return rev;
            });
            props.setProcessed(updated);
        }, onChange: function (uuid, x) {
            var updated = props.processed.map(function (rev) {
                if (rev.uuid === uuid) {
                    if (rev.customMeta && rev.customMeta.length > x.key) {
                        var meta = rev.customMeta[x.key];
                        meta.value = x.value;
                        meta.formattedValue = x.value;
                    }
                }
                return rev;
            });
            props.setProcessed(updated);
        }, currentProject: props.currentProject, selectedLanguage: props.selectedLanguage, getLocalization: props.getLocalization, items: props.processed, errors: props.errors, metaDataColumns: props.metas, failedColumns: props.failedColumns, displayLocked: true, uuid: props.uuid }))); });
